export const talent = {
  en: {
    // Talent Applications
    applications: {
      title: "Talent Applications",
      total: "total",
      pending: "pending",
      reviewing: "reviewing",
      searchPlaceholder: "Search by name or email...",
      allStatus: "All Status",
      clear: "Clear",
      applicant: "Applicant",
      areaOfExpertise: "Area of Expertise",
      country: "Country",
      workLinks: "Work Links",
      resume: "Resume",
      status: "Status",
      applied: "Applied",
      noApplications: "No talent applications found",
      viewDetails: "View Details",
      viewResume: "View Resume",
      markReviewing: "Mark Reviewing",
      approve: "Approve",
      reject: "Reject",
      link: "link",
      links: "links",
      view: "View",
      assignedRoles: "Assigned Roles",
      assignedIndustries: "Assigned Industries",
      adminNotes: "Admin Notes",
      adminNotesPlaceholder: "Add notes about this applicant...",
      saveNotes: "Save Notes",
      savingNotes: "Saving...",
      errorLoading: "Error loading applications:",
      viewResumePdf: "View Resume (PDF)",
      noApplicationsInColumn: "No applications",
    },
    // Talent Profile
    profile: {
      brand: "SOLARIIS",
      submitted: "Profile submitted!",
      thankYou: "Thank you for joining our talent network",
      reviewing: "We're reviewing your profile",
      reviewDesc: "Our team will review your application and reach out when we find opportunities that match your expertise.",
      yourInfo: "Your Information",
      whatHappensNext: "What happens next?",
      step1: "Our team reviews your profile and resume",
      step2: "We match you with relevant projects",
      step3: "We contact you when there's a good fit",
      questions: "Questions? Contact us at",
      email: "talent@solariis.com",
    },
  },
  es: {
    applications: {
      title: "Aplicaciones de Talento",
      total: "total",
      pending: "pendientes",
      reviewing: "en revisión",
      searchPlaceholder: "Buscar por nombre o correo...",
      allStatus: "Todos los Estados",
      clear: "Limpiar",
      applicant: "Aplicante",
      areaOfExpertise: "Área de Especialización",
      country: "País",
      workLinks: "Enlaces de Trabajo",
      resume: "Currículum",
      status: "Estado",
      applied: "Aplicó",
      noApplications: "No se encontraron aplicaciones de talento",
      viewDetails: "Ver Detalles",
      viewResume: "Ver Currículum",
      markReviewing: "Marcar en Revisión",
      approve: "Aprobar",
      reject: "Rechazar",
      link: "enlace",
      links: "enlaces",
      view: "Ver",
      assignedRoles: "Roles Asignados",
      assignedIndustries: "Industrias Asignadas",
      adminNotes: "Notas del Admin",
      adminNotesPlaceholder: "Agregar notas sobre este aplicante...",
      saveNotes: "Guardar Notas",
      savingNotes: "Guardando...",
      errorLoading: "Error al cargar aplicaciones:",
      viewResumePdf: "Ver Currículum (PDF)",
      noApplicationsInColumn: "Sin aplicaciones",
    },
    profile: {
      brand: "SOLARIIS",
      submitted: "¡Perfil enviado!",
      thankYou: "Gracias por unirte a nuestra red de talento",
      reviewing: "Estamos revisando tu perfil",
      reviewDesc: "Nuestro equipo revisará tu aplicación y te contactará cuando encontremos oportunidades que coincidan con tu experiencia.",
      yourInfo: "Tu Información",
      whatHappensNext: "¿Qué sigue?",
      step1: "Nuestro equipo revisa tu perfil y currículum",
      step2: "Te emparejamos con proyectos relevantes",
      step3: "Te contactamos cuando hay una buena oportunidad",
      questions: "¿Preguntas? Contáctanos en",
      email: "talent@solariis.com",
    },
  },
};
